import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';
import { MuscleGroup } from '../interfaces/muscle-group';
import { Observable } from 'rxjs';
import { Exercise } from '../interfaces/exercise';
import { Tutorial } from '../interfaces/tutorial';
import { IntencityPrinciples } from '../interfaces/intencity-principles';
import { GymMachine } from '../interfaces/gym-machine';

@Injectable({
  providedIn: 'root',
})
export class ExerciseService {
  MUSCLE_GROUPS_apiUrl = environment.apiUrl + '/muscle-group';
  EXERCISE_GROUPS_apiUrl = environment.apiUrl + '/exercise';
  TUTORIALS_apiUrl = environment.apiUrl + '/tutorial';
  INTENSITY_PRINCIPLES_apiUrl = environment.apiUrl + '/intencity-principles';
  GYM_MACHINE_apiUrl = environment.apiUrl + '/gym-machine';

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  // Muscle Groups
  getMuscleGroups(): Observable<MuscleGroup[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<MuscleGroup[]>(this.MUSCLE_GROUPS_apiUrl + '/all', {
      headers: httpHeaders,
    });
  }

  // CRUD Exercises

  createExercise(exercise: Exercise) {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<Exercise[]>(this.EXERCISE_GROUPS_apiUrl, exercise, {
      headers: httpHeaders,
    });
  }

  getExerciseByMuscleGroup(muscleGroupId: number): Observable<Exercise[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<Exercise[]>(
      this.MUSCLE_GROUPS_apiUrl + '/' + muscleGroupId + '/exercise',
      { headers: httpHeaders }
    );
  }

  getExerciseDetail(exerciseId: number): Observable<Exercise> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<Exercise>(
      this.EXERCISE_GROUPS_apiUrl + '/' + exerciseId,
      { headers: httpHeaders }
    );
  }

  updateExercise(exercise: Exercise): Observable<Exercise> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.patch<Exercise>(
      `${this.EXERCISE_GROUPS_apiUrl}/${exercise.id!}`,
      exercise,
      { headers: httpHeaders }
    );
  }

  // CRUD Tutorials

  createTutorial(exerciseId: number, tutorial: Tutorial): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<void>(
      `${this.EXERCISE_GROUPS_apiUrl}/${exerciseId}/tutorial`,
      tutorial,
      { headers: httpHeaders }
    );
  }

  // It's not in notion yet
  getTutorials() {}

  updateTutorials(tutorial: Tutorial): Observable<Tutorial> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.patch<Tutorial>(
      `${this.TUTORIALS_apiUrl}/${tutorial.id}`,
      tutorial,
      { headers: httpHeaders }
    );
  }

  deleteTutorial(tutorial: Tutorial): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.delete<void>(`${this.TUTORIALS_apiUrl}/${tutorial.id}`, {
      headers: httpHeaders,
    });
  }

  // Intensity Principles
  getIntensityPrinciples(): Observable<IntencityPrinciples[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<IntencityPrinciples[]>(
      this.INTENSITY_PRINCIPLES_apiUrl + '/all',
      { headers: httpHeaders }
    );
  }

  getGymMachine(): Observable<GymMachine[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<GymMachine[]>(this.GYM_MACHINE_apiUrl, {
      headers: httpHeaders,
    });
  }
}
